<template>
  <li class="profile-nav onhover-dropdown p-0 mr-0">
    <div class="media profile-media">
      <img
      v-if="profilePicture"
        class="rounded-circle"
        height="40"
        width="40"
        :src="`data:image/png;base64,${profilePicture}`"
        alt=""
      />
      <img
        v-else
        class="rounded-circle"
        height="40"
        width="40"
        :src="usersImage"
        alt=""
      />
      <div class="media-body">
        <span>{{userName}}</span>
        <p class="mb-0 font-roboto">
          Customer <i class="middle fa fa-angle-down"></i>
        </p>
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div">
      <li>
        <a @click="logout"
          ><feather type="log-in"></feather><span>Log out</span></a
        >
      </li>
    </ul>
  </li>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: 'Profile',
    data:() => ({
      usersImage: require('@/assets/TAJimages/user/user.png'),
    }),
    computed: {
      ...mapState({
        accounts: (state) => state.dashboard.dashboardData,
        // eslint-disable-next-line no-confusing-arrow
        profilePicture: state => state.dashboard ? state.dashboard.profilePicture : null,
        details: state => state.dashboard.dashboardData,
      }),
      userName() {
        return this.accounts ? this.accounts.customerDetails.firstName : null;
      },
      userImage() {
        return this.details ? this.details.customerDetails.userName : null;
      },
    },
    async mounted() {
      // await this.$store.dispatch('dashboard/getProfilePicture', this.userImage);
    },
    methods: {
      // logout function
      logout() {
        this.$store.dispatch('logout');
      }
    },
  };
</script>
